module.exports = __webpack_public_path__ + "static/media/spaceguy.674eeae5.png";